<template>
    <v-dialog :model-value="modelValue" persistent width="auto">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <v-progress-circular
              v-if="!completed && !error"
              :size="20"
              :thickness="7"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <template v-if="error">
              <div class="font-weight-bold text-error mb-2">Import failed</div>
              <div class="import-error-message">{{ error }}</div>
            </template>
            <div v-else-if="completed">Import completed!</div>
            <div v-else>Importing tasks...</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="error"
            color="primary"
            @click="$emit('close')"
          >
            Close
          </v-btn>
          <v-btn
            v-else-if="completed"
            color="primary"
            @click="$emit('done')"
          >
            Done
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <script setup>
  defineProps({
    modelValue: {
      type: Boolean,
      required: true
    },
    completed: {
      type: Boolean,
      required: true
    },
    error: {
      type: String,
      default: null
    }
  });

  defineEmits(['update:model-value', 'done', 'close']);
  </script>

  <style scoped>
  .import-error-message {
    max-width: 400px;
    white-space: pre-line;
  }
  </style>
